import { render, staticRenderFns } from "./OrderProductAccounting.vue?vue&type=template&id=c3a83e60&scoped=true&"
import script from "./OrderProductAccounting.vue?vue&type=script&lang=js&"
export * from "./OrderProductAccounting.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductAccounting.vue?vue&type=style&index=0&id=c3a83e60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a83e60",
  null
  
)

export default component.exports